var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-modal',{attrs:{"id":"modal_hotelPrecios","size":"lg","title":_vm.titulo,"hide-header":"","ok-only":"","content-class":"shadow","button-size":"sm","centered":"","ok-title":"Cancelar","ok-variant":"outline-primary"}},[_c('hotelPrecios')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }